export const RedshiftLogo = ({ height = 35 }) => (
  <svg
    enableBackground="new 0 0 1615 1783.7"
    viewBox="0 0 1615 1783.7"
    xmlns="http://www.w3.org/2000/svg"
    height={height}
  >
    <path d="m807.5 1363.8 678.3 161.5v-1270.5l-678.3 161.5z" fill="#205b97" />
    <path
      d="m1485.8 254.8 129.2 64.6v1141.3l-129.2 64.6zm-678.3 1109-678.3 161.5v-1270.5l678.3 161.5z"
      fill="#5193ce"
    />
    <path d="m129.2 254.8-129.2 64.6v1141.3l129.2 64.6z" fill="#205b97" />
    <path
      d="m979.8 1783.7 258.4-129.2v-1525.3l-258.4-129.2-79 847z"
      fill="#5193ce"
    />
    <path
      d="m635.2 1783.7-258.4-129.2v-1525.3l258.4-129.2 79 847z"
      fill="#205b97"
    />
    <path d="m635.2 0h348.1v1780.1h-348.1z" fill="#2e73b7" />
  </svg>
);

export const RedshiftIcon: React.FC<{
  className?: string;
}> = ({ className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="0"
      aria-label="Redshift"
      className={className}
    >
      <path d="M4 6 L7 4 L7 20 L4 18 Z" fill="currentColor" opacity="0.6" />
      <rect
        x="7"
        y="3"
        width="3"
        height="18"
        rx="0.5"
        fill="currentColor"
        opacity="0.8"
      />
      <rect x="11" y="2" width="3" height="20" rx="0.5" fill="currentColor" />
      <rect
        x="15"
        y="3"
        width="3"
        height="18"
        rx="0.5"
        fill="currentColor"
        opacity="0.8"
      />
      <path d="M18 4 L21 6 L21 18 L18 20 Z" fill="currentColor" opacity="0.6" />
    </svg>
  );
};
